var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"players"},_vm._l((_vm.league.rankedUsers),function(user){return _c('player',{key:user._id,attrs:{"league":_vm.league,"user":user}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }